defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardContent',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril'
  ],
  function (m) {
    // Context:
    const CardContent = ({ title, subtitle, $header, $content, $footer, className }) => {

      // Return:
      return m('.play-together-club-card__inner-content', {
        class: className
      }, [
        $header ? m('.card-content__header', $header) : null,
        m('.card-content__body', [
          title || subtitle ? m('.card-content__body-header', [
            title ? m('.card-content__title', title) : null,
            subtitle ? m('.card-content__subtitle', subtitle) : null
          ]) : null,
          $content ? m('.card-content__content', $content) : null
        ]),
        $footer ? m('.card-content__footer', $footer) : null,
      ]);
    };

    // Public functions:
    return CardContent;
  });
